// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  depthId: __t.u64().primaryKey().name("depth_id"),
  stationKey: __t.string().name("station_key"),
  commodity: __t.string(),
  epoch: __t.u64(),
  boughtU: __t.u32().name("bought_u"),
  soldU: __t.u32().name("sold_u"),
  updatedAt: __t.timestamp().name("updated_at"),
});
